import React, { useEffect, useState, useContext, useRef } from "react";
import axiosInstance from "../../../ReusableComponents/Axios";
import { LoadContext } from "../../../ReusableComponents/LoadingContex";
import { useSelector } from "react-redux";
import ReuseTable from "../../../ReusableComponents/Table";
import NCLLOgo from "../../../Student/Assests/Images/NCLogo.png";
import { Row, Col } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import { FaSchool } from "react-icons/fa";
import { FaGraduationCap } from "react-icons/fa";
import { BsFillPeopleFill } from "react-icons/bs";
import { SiTicktick } from "react-icons/si";
import { VscGraph } from "react-icons/vsc";
import { ImBooks } from "react-icons/im";
import { FaLightbulb } from "react-icons/fa";
import { renderToString } from "react-dom/server";
import { SlCalender } from "react-icons/sl";
import { MdAssessment } from "react-icons/md";
const SSPRCard = (props) => {
  const { SetLoad } = useContext(LoadContext);
  const ReportsRef = useRef();
  const location = useLocation();
  const items = useSelector((state) => state.userDetailsData.LoginDetails);
  const SelectDate = useSelector((state) => state.DateDetailsData.DateDetails);
  const [SGWParticipationR, SetSGWParticipationR] = useState([]);
  const [SubPercentage, SetSubPercentage] = useState([]);
  const [SubPerformance, SetSubPerformance] = useState();
  const [FocusArea, SetFocusArea] = useState();
  const [SelectGrade, SetSelectGrade] = useState(10);
  const ExpandGrades =
    SelectGrade === 10
      ? [6, 7, 8, 9, 10]
      : SelectGrade === 1
        ? [1, 2, 3, 4, 5]
        : [11, 12];

  const fetchAllReports = async () => {
    SetLoad(true);
    try {
      const EGrades = ExpandGrades.join(",");
      const [participationRes, SubPerc, SubPerf, Focuson] =
        await Promise.allSettled([
          axiosInstance.get(
            `/Principal/GetSubjectGradeWiseParticipationReport?SchoolId=${location.state?.SchoolId }&ContestCreationId=${SelectDate?.value}&AssessmentType=${SelectDate?.assessmentType}`,
          ),
          axiosInstance.get(
            `/Principal/GetPrincipalSubjectAveragePercentage?SchoolId=${location.state?.SchoolId }&ContestCreationId=${SelectDate?.value}&Grades=${EGrades}&AssessmentType=${SelectDate?.assessmentType}`,
          ),
          axiosInstance.get(
            `/Principal/GetPrincipalGradeSubjectAveragePercentage?SchoolId=${location.state?.SchoolId }&ContestCreationId=${SelectDate?.value}&Grades=${EGrades}&AssessmentType=${SelectDate?.assessmentType}`,
          ),
          axiosInstance.get(
            `/Principal/GetPrincipalFocusOnLOPerformance?SchoolId=${location.state?.SchoolId }&ContestCreationId=${SelectDate?.value}&AssessmentType=${SelectDate?.assessmentType}`,
          ),
        ]);

      /* Participation */
      const filtered = participationRes?.value?.data[0].grade
        ? participationRes?.value?.data?.filter((g) =>
            ExpandGrades.includes(g.grade),
          )
        : [];
      const formatdate = {
        grade: "Total",
        registered: filtered?.reduce((sum, item) => sum + item.registered, 0),
        participated: filtered?.reduce(
          (sum, item) => sum + item.participated,
          0,
        ),
        Bold: true,
      };
      SetSGWParticipationR(
        filtered?.length > 0 ? [...filtered, formatdate] : [],
      );

      /* SubJect Performance */
      const total = {
        subjectName: "School",
        subjectAveragePercentage:
          SubPerc?.value?.data[0]?.overallAveragePercentage,
      };
      SetSubPercentage([total, ...SubPerc?.value.data]);
      /* Subject Grade Perfromance */
      const subjects = [
        ...new Set(SubPerf.value.data.map((s) => s.subjectName)),
      ];
      const FormatDta = SubPerf.value.data.reduce((acc, item) => {
        if (!acc[item?.grade]) {
          acc[item?.grade] = { Grade: `${item.grade}` };
        }
        acc[item.grade][item.subjectName] = item.subjectAveragePercentage;
        return acc;
      }, {});
      SetSubPerformance({ subjects, data: Object.values(FormatDta) });
      /* Focus area */
      const Subjects = Focuson?.value.data
        ?.filter((g) => ExpandGrades.includes(g.grade))
        .reduce((acc, item) => {
          if (!acc[item.subjectName]) {
            acc[item.subjectName] = {};
          }

          if (!acc[item.subjectName][item?.grade]) {
            acc[item.subjectName][item?.grade] = {
              LO: [],
            };
          }
          acc[item.subjectName][item?.grade].LO.push(item);
          return acc;
        }, {});
      SetFocusArea(Subjects);
    } catch (error) {
      console.log(error);
    } finally {
      SetLoad(false);
    }
  };

  useEffect(() => {
    if (SelectDate?.value) {
      fetchAllReports();
    }else{
       SetSGWParticipationR([]);
       SetSubPercentage([]);
       SetFocusArea();
    }
  }, [SelectDate, SelectGrade]);
  // const Color = (e) => {
  //   switch (true) {
  //     case e >= 75:
  //       return "green";
  //     case e >= 50 && e < 75:
  //       return "orange";
  //     case e < 50:
  //       return "red";
  //   }
  // };
  const Color = (e) => {
    switch (true) {
      case e >= 75:
        return "#009161";
      case e >= 50 && e < 75:
        return "#1337aa";
      case e < 50:
        return "#e95100";
    }
  };
  // const SubjectColors = (Sub) => {
  //   switch (Sub) {
  //     case "English":
  //       return "#F3EBFF";
  //     case "Mathematics":
  //       return "#FFF7DF";
  //     case "Science":
  //       return "#E0F2FF";
  //     case "Physics and Chemistry":
  //       return "#D2FFF2";
  //     case "Biology":
  //       return "#E7E7E7";
  //   }
  // };
  const SubjectColors = (Sub) => {
    switch (Sub) {
      case "English":
        return "#1ca078";
      case "Mathematics":
        return "#3653b7";
      case "Science":
        return "#ec6722";
      case "Physics and Chemistry":
        return "#875998";
      case "Biology":
        return "#7d859e";
      case "School":
        return "#bb5f5f";
        case "BioTechnology":
        return "#bb995f";
      case "Hindi":
        return "#f96393";
     case "Telugu":
        return "#AD46FF";
    }
  };
  const SPerformanceColumns = [
    { name: "Grade", selector: "Grade" },
    ...(SubPerformance?.subjects.map((Subject) => ({
      name: Subject,
      selector: Subject,
      cell: (row) => (
        <div style={{ color: Color(row[Subject]) }}>
          {row[Subject] ? `${row[Subject]}%` : "-"}
        </div>
      ),
    })) || []),
  ];

  const copyAllStyles = () => {
    let styles = "";
    for (let sheet of document.styleSheets) {
      try {
        if (sheet.href) {
          styles += `<link rel="stylesheet" href="${sheet.href}" />`;
        } else if (sheet.cssRules) {
          // inline style blocks (used by SCSS injected styles)
          let rules = "";
          for (let rule of sheet.cssRules) {
            rules += rule.cssText;
          }
          styles += `<style>${rules}</style>`;
        }
      } catch (err) {
        console.log("Skipping stylesheet", err);
      }
    }
    return styles;
  };

  const DownloadPDF = async() => {
    try {
        const payload = {
          userTypeId: items?.userTypeId || 0,
          userId: items?.userId || 0,
          reportType: "Principal Report Card",
          contestCreationId: SelectDate?.value || 0,
          assessmentTypeId: SelectDate?.assessmentType || 0
        };
        await axiosInstance.post("/NCLAdmin/InsertReportExportLog", payload);
    
      } catch (error) {
        console.error("Error logging report download:", error);
      }
    const stylesheets = copyAllStyles();
    const printContents = ReportsRef.current.innerHTML;
    const printWindow = window.open("", "", "height=800,width=600");
    const filename = `${location?.state?.SchoolName || items?.fullName}_${
      SelectDate?.assessmentType === 1 ? "SODHANA" : "SADHANA"
    }_ReportCard_${
      SelectGrade > 10 ? "11 - 12" : SelectGrade < 2 ? "1-5" : "6 - 10"
    }`;
    printWindow.document.write(`
            <html>
            <head>
             ${stylesheets}
        <style>
             
          /* General styles for print position: relative; zoom: 0.9; */
          @media print {
            body {
            font-size: 10px;
            }
            /* Watermark style */
            .watermark {
              position: fixed;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%) rotate(-55deg);
              font-size: 80px;
              color: rgba(0, 0, 0, 0.06); /* low opacity */
              pointer-events: none;
              z-index: 9999;
              white-space: nowrap;
            }
            
            .Icons-Div {
  display: flex;
  justify-content: center;
  align-items: center;
  white-space: nowrap;
  gap: 20px;
}

.Icons-Div div {
  flex: 1;
  text-align: center;
  
}
  .Details-Div{
display: grid;
    grid-template-columns:repeat(3, auto);
    gap: 10px;
     
  -webkit-print-color-adjust: exact !important;
  print-color-adjust: exact !important;
}
  table th {
       background-color: #1e40ae !important; /* your theme color */
       color: #f6fffe !important;
       -webkit-print-color-adjust: exact !important;
       print-color-adjust: exact !important;
font-size: 12px;
     }
        table tbody td,.P-Details {
  font-size: 12px !important;
}
      
.Icons-Div img {
              width: 45%;
              // height: 60px;
            }
             
                   .EndReport{
                  margin-top: 15px;
              }
                     .Card,
      ul,li {
        page-break-inside: avoid;
        break-inside: avoid;
         font-size: 10px !important;
      } 
 .SubHeading,.MainHeading{
 font-weight:700 !important;
 font-size: 14px;
 color: #1e40ae;}
            /* Ensure watermark appears on every page */
            @page {
              size: A4;
              margin: 10mm;
            }
          }
        </style>
      </head>
      <body>
      <div class="Icons-Div">
     
       <img src="${NCLLOgo}" alt="NCL Logo" />
      </div>
<hr/>
<div class="mb-3" style="border: 2px solid #1e40ae; border-radius: 10px; padding: 6px 10px;">
<div class="MainHeading mt-3 mb-2"> School Performance Report for Principals </div>

        <div class="Card  Details-Div mb-3">
                <div class="dflex"> <b class="dflex gap-1"> 🏫 School :</b>  ${location?.state?.SchoolName || items?.fullName}</div>
                <div class="dflex"> <b class="dflex gap-1">🎓Grades : </b> ${
                  SelectGrade > 10
                    ? "11 - 12"
                    : SelectGrade < 2
                      ? "1-5"
                      : "6 - 10"
                }</div>
                 <div class="dflex"> <b class="dflex gap-1"> 📊 Assessment Name : </b> ${SelectDate?.display}</div>
                <div class="dflex"> <b class="dflex gap-1">📆 Date of Assessment : </b> ${
                  SelectDate?.examStartDate
                }</div>
                <div class="dflex"> <b class="dflex gap-1"> 👥Total Registered : </b>${
                  SGWParticipationR?.find((item) => item.grade === "Total")
                    ?.registered
                } </div>
                <div class="dflex" > <b class="dflex gap-1">  ✅Total Participated : </b>  ${
                  SGWParticipationR?.find((item) => item.grade === "Total")
                    ?.participated
                } </div>
            </div>
            </div>
        <div class="watermark">NORTH SOUTH FOUNDATION</div>
   
      ${printContents}
      <br/>
      <br/>
      <br/>
      <br/>
      <br/>
      <br/>
      <div class="Icons-Div"> <div>**  Address: Room 305–307, Third Floor, Model House, Punjagutta, Hyderabad, Telangana 500082  **</div></div>
      <script>
          window.onload = function() {
            setTimeout(() => {
              document.title = "${filename}";
              window.print();
              window.close();
              }, 400);
              }
              <\/script>
              </body>
              </html>
              `);
    printWindow.document.close();
  };
  //  background-color: #ECF7FF !important;
        // ${renderToString(<FaSchool />)}
// ${renderToString(<FaGraduationCap />)}
// ${renderToString(<BsFillPeopleFill />)}
// ${renderToString(<SiTicktick />)}
// ${renderToString(<MdAssessment />)}
// ${renderToString(<SlCalender />)}
  const ParticipationColumns = [
    {
      name: "Grade",
      selector: "grade",
      cell: (row) => (
        <div style={row.Bold ? { fontWeight: "700" } : {}}>{row?.grade}</div>
      ),
    },

    {
      name: "Registered",
      selector: "registered",
      cell: (row) => (
        <div style={row.Bold ? { fontWeight: "700" } : {}}>
          {row?.registered}
        </div>
      ),
    },
    {
      name: "Participated",
      selector: "participated",
      cell: (row) => (
        <div style={row.Bold ? { fontWeight: "700" } : {}}>
          {row?.participated}
        </div>
      ),
    },
    {
      name: "Participated %",
      cell: (row) => (
        <div
          style={{
            fontWeight: row.Bold ? "700" : "normal",
            color: Color(Math.round((row.participated / row.registered) * 100)),
          }}
        >
          {Math.round((row.participated / row.registered) * 100)}%
        </div>
      ),
    },
  ];
  return (
    <div className=" TeacherBgImage ">
      <div
        className="p-2 mb-3"
        style={{ border: "2px solid #1e40ae", borderRadius: "10px" }}
      >
        <div className="dflex alignitems JSBetween">
          <div></div>
          <div className="MainHeading" style={{ color: "#1e40ae" }}>
            {" "}
            School Performance Report for Principals{" "}
          </div>
          <button
            className="Buttons"
            onClick={() => DownloadPDF()}
            disabled={!SGWParticipationR?.[0]?.registered}
          >
            {" "}
            Download Report{" "}
          </button>
        </div>

        <div className="dflex JSBetween mt-3 mb-3">
          <div>
            <b>
              {/* <FaSchool /> */}
              🏫 School :
            </b>{" "}
            {location?.state?.SchoolName || items?.fullName}
          </div>
          <div className="dflex gap-3 alignitems  JCCenter">
            <b className="dflex gap-1">
              {" "}
              {/* <FaGraduationCap /> */}
              🎓 Grades :{" "}
            </b>
            {[1, 10, 11].map((num) => (
              <div className="dflex gap-1">
                <input
                  type="radio"
                  value={SelectGrade}
                  checked={SelectGrade === num}
                  onClick={() => SetSelectGrade(num)}
                />
                {num > 10 ? "11 - 12" : num < 2 ? "1 - 5" : "6 - 10"}
              </div>
            ))}
          </div>
          <div style={{ display: "inline-flex" }} className="alignitems">
            <b className="dflex gap-2">
              {" "}
              {/* <BsFillPeopleFill /> */}
              👥
              Total Registered :{" "}
            </b>{" "}
            <span className="ft-18">
              &nbsp;{" "}
              {
                SGWParticipationR?.find((item) => item.grade === "Total")
                  ?.registered
              }
            </span>{" "}
          </div>
          <div style={{ display: "inline-flex" }} className="alignitems">
            <b className="dflex gap-2">
              {" "}
              {/* <SiTicktick /> */}
              ✅
              Total Participated :{" "}
            </b>{" "}
            <span className="ft-18">
              &nbsp;{" "}
              {
                SGWParticipationR?.find((item) => item.grade === "Total")
                  ?.participated
              }{" "}
            </span>
          </div>
        </div>
      </div>
      {SGWParticipationR.length > 1 ? (
        <div ref={ReportsRef}>
          <Row>
            <Col>
              <div className="SubHeading mb-2" style={{ fontWeight: 700 }}>
                {/* <VscGraph /> */}
                 📊Participation Overview
              </div>
              <ReuseTable
                className="NCLDataTable ReportCardTable Card"
                data={SGWParticipationR}
                columns={ParticipationColumns}
              />
            </Col>
            <Col className="dflex flexd-column">
              <div className="SubHeading mb-2" style={{ fontWeight: 700 }}>
                Performance Overview
              </div>
              <div
                className=" dflex flexd-column w-100 h-100 alignitems gap-3"
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(2,1fr)",
                }}
              >
                {SubPercentage.length > 1 ? (
                  SubPercentage?.map((SUB, index) => (
                    <>
                      <div
                        className="dflex gap-3 flexd-column JCCenter alignitems h-100 Card P-Details "
                        style={{
                          backgroundColor: SubjectColors(SUB.subjectName),
                          WebkitPrintColorAdjust: "exact",
                          printColorAdjust: "exact",
                          color: "#fff",
                        }}
                      >
                        <span style={{ fontWeight: 700 }}>
                          {SUB.subjectName} Average
                        </span>
                        <span>{SUB.subjectAveragePercentage}%</span>
                      </div>
                    </>
                  ))
                ) : (
                  <div className="ErrorMessage">
                    {process.env.REACT_APP_NODATAFOUND_Participated}
                  </div>
                )}
              </div>
            </Col>
          </Row>
       
          <div className="SubHeading mt-3 mb-2" style={{ fontWeight: 700 }}>
            {/* <ImBooks /> */}
            📚 Subject-wise Percentage Across Grades
          </div>
          <ReuseTable
            className="NCLDataTable ReportCardTable Card"
            data={SubPerformance?.data || []}
            columns={SPerformanceColumns}
          />
          <div className="SubHeading mt-3 " style={{ fontWeight: 700 }}>
            {/* <FaLightbulb /> */}
            💡 Focus Areas
          </div>
          The percentage shows the percent of students that got the topic
          correct
          {FocusArea &&
            Object.entries(FocusArea)?.map(([Subject, Grades]) => (
              <>
                <div
                  className="SubHeading mt-3  p-2"
                  style={{
                    fontWeight: 700,
                    backgroundColor: SubjectColors(Subject),
                    borderRadius: "10px",
                    color: "#fff",
                    WebkitPrintColorAdjust: "exact",
                    printColorAdjust: "exact",
                  }}
                >
                  {Subject}
                </div>

                <div
                  className="gap-3"
                  style={{
                    display: "grid",
                    gridTemplateColumns: "1fr 1fr 1fr",
                  }}
                >
                  {Object.entries(Grades)?.map(([Grade, LOs]) => (
                    <div
                      className="Card TDFArea mt-2"
                      style={{
                        // backgroundColor: SubjectColors(Subject),
                        WebkitPrintColorAdjust: "exact",
                        printColorAdjust: "exact",
                      }}
                    >
                      <div style={{ color: "#2949b2" }}>
                        Grade {Grade} - Areas of improvement
                      </div>
                      <hr className="m-1" />
                      {/* <div></div> */}
                      <ul className="m-0">
                        {" "}
                        {LOs.LO.map((lo) => (
                          <li>
                            {lo?.subTopic && `${lo?.subTopic} : `}
                            {lo?.lo && `${lo?.lo} - `}{" "}
                            {lo?.subjectAveragePercentage}%
                          </li>
                        ))}{" "}
                      </ul>
                    </div>
                  ))}
                </div>
              </>
            ))}
        </div>
      ) : (
        <div className="ErrorMessage">
          {process.env.REACT_APP_NODATAFOUND_Participated}
        </div>
      )}
    </div>
  );
};
export default SSPRCard;
